/* ============================================================================
 * DIE PLATTFORM ALS ANWENDUNG AUF DEM RECHNER
 * ============================================================================
 *
 * ORIGINALTEXT MARVIN (22.09.2026)
 *   „ich will die webseite auf dem pc als app installieren. musst du da etwas
 *    für vorbereiten?"
 *
 * JA, 3 DINGE - und nur eines davon ist diese Datei:
 *
 *   1. Die Beschreibung der Anwendung (`public/manifest.webmanifest`) mit
 *      Name, Startadresse, Anzeigeart und Symbolen. Ohne sie bietet kein
 *      Browser das Installieren an.
 *   2. Die Symbole, darunter eines zum Beschneiden (`app-maskable-512.png`):
 *      Windows und Android legen das Symbol in einen Kreis oder ein
 *      abgerundetes Quadrat. Ein Zeichen, das dabei angeschnitten wird,
 *      sieht aus wie ein Fehler.
 *   3. Den Begleiter (`public/begleiter.js`), den das Angebot in der
 *      Adresszeile verlangt - und der mit Absicht NICHTS zwischenspeichert.
 *      Warum, steht in seinem Kopf.
 *
 * ----------------------------------------------------------------------------
 * ER WIRD NUR ÜBER EINE SICHERE VERBINDUNG ANGEMELDET
 * ----------------------------------------------------------------------------
 * Ein Begleiter läuft nur über HTTPS oder auf `localhost`. Im
 * Entwicklungsbetrieb über eine IP-Adresse gäbe es sonst jedes Mal einen
 * roten Eintrag in der Browserkonsole, und **eine Konsole voller Meldungen,
 * die nichts bedeuten, ist eine Konsole, in der niemand mehr die eine sucht,
 * die etwas bedeutet.**
 */
export function alsApp(): void {
  if (!('serviceWorker' in navigator)) return;
  if (!window.isSecureContext) return;

  /* NACH DEM LADEN UND NICHT DAVOR. Die Anmeldung des Begleiters läuft über
     dieselbe Leitung wie die erste Abfrage der Oberfläche; davor angestossen
     verzögert sie genau den Bildschirm, auf den jemand wartet. */
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/begleiter.js', { scope: '/' })
      .catch(() => {
        /* STILL. Das Installieren ist eine Bequemlichkeit und keine
           Voraussetzung: scheitert die Anmeldung (fremde Einstellung im
           Browser, privates Fenster, Unternehmensrichtlinie), arbeitet die
           Plattform im Browser unverändert weiter. */
      });
  });
}
